<template>
  <div class="w100">
    <!-- 导航栏 -->
    <div class="shopNav grayBg">
      <div class="navContent">
        <span :class="{active:active===1}" @click="changeHandler(1)">店铺主页</span>
        <span :class="{active:active===2}" @click="changeHandler(2)">案例中心</span>
        <span :class="{active:active===3}" @click="changeHandler(3)">企业信息</span>
      </div>
    </div>
    <div class="shopCommon">
        <div class="busRight">
          <div class="shopBanner">
            <div class="block">
              <el-carousel height="290px">


                <div class="shopInfoWrap">
                  <div class="shopInfo">
                    <div class="shopName">
                        <div class="shopName-left">
                          <!-- :src="smallCart.logoUrl | imagePath" -->
                          <img :src="smallCart.logoUrl " alt="">
                        </div>
                        <div class="shopName-right">
                            <div class="shopName-right_top">
                              {{smallCart.storeName}}
                            </div>
                            <div class="shopName-right_bottom">
                                <span v-show="smallCart.isCompany">营</span>
                                <span  v-show="smallCart.isPay">认</span>
                            </div>
                        </div>
                    </div>

                    <div class="productNum">
                      <dl>
                        <dt>{{smallCart.proNum}}</dt>
                        <dd>在售产品</dd>
                      </dl>
                      <dl>
                        <dt>{{smallCart.salesVolume}}</dt>
                        <dd>成交量</dd>
                      </dl>
                      <dl>
                        <dt>{{smallCart.caseNum}}</dt>
                        <dd>服务案例</dd>
                      </dl>
                    </div>
                    <div class="adress">
                      地址：{{smallCart.address}}
                    </div>
                    <div class="collection" @click="collection" v-show="!isCollect">
                      收藏店铺
                    </div>
                    <div class="collection" @click="collection1" v-show="isCollect">
                      取消收藏
                    </div>
                    <!-- <div class="contact">
                      电话联系
                    </div> -->
<!--                    <div @click="dialogVisible = true;phone()" class="contact">电话联系</div>-->

                  </div>
                </div>



                <el-carousel-item v-for="(item,index) in bannerInfos.collect" :key="index" v-show="!isCaseLunbo.length==0">
                  <img :src="item | imagePath">
                </el-carousel-item>
                <el-carousel-item v-if="isCaseLunbo.length==0">
                  <img src="../../assets/image/caseLunbo.jpg" alt="" />
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
      </div>


       <el-dialog title="" :visible.sync="dialogVisible">
        <div class="popTop">
          <p class="storeName">{{store.storeShortName}}</p>
        <div class="storeMobile">
          <div>
            <span>
              <img src="../../assets/image/phone.png" alt="" align="middle">
            </span>
            <span>{{store.mobile}}</span>
          </div>
          <div class="streFooter">
            注：为了您的交易安全，请走孔雀有礼线上交易如遇可疑商家，可及时向平台投诉举报！
          </div>
        </div>
        </div>
      </el-dialog>
    </div>
</template>
<script>
export default {
  props: ['storeId'],
  data() {
    return {
      isCaseLunbo:"", //商家是否上传了店铺轮播图
      isCollect:"", //是否收藏了店铺
      storeId1:this.$route.params.id,
       store: {}, //保存弹窗信息的对象
        dialogVisible: false, //电话弹窗显示与否
      active: 1,
      shopInfos: {}, // 公司信息
      storeInfo: {}, //店铺信息
      bannerInfos: {}, // banner
      smallCart:{} //店铺信息卡片
    }
  },
  created(){
    // this.storeId=this.$route.params.id;
    // console.log(this.$route.params.id,11)
  },
  mounted() {

    const { params } = this.$route
    const { id } = params
    this.shopInfo(id)
    this.bannerInfo(id)
  },
  methods: {
    collection(){ //点击收藏店铺
        this.isCollect=true;
      this.$http.get('collectStore/add', { params: { storeId: this.storeId1 } }).then(res => {
      })


    },
    collection1(){ //取消收藏
    this.isCollect=false;
       this.$http.get('collectStore/deleteByStoreId', { params: { storeId: this.storeId1 } }).then(res => {
      })
    },
     phone(){ //联系商家
      this.$http.get('store/info', { params: { storeId: this.storeId1 } }).then(res => {
        this.store = res.data.data;
      })
    },
    // 左侧获取公司信息
    shopInfo(id) {
      this.$http.get('/company', { params: { storeId: id } }).then(res => {
        const { data } = res.data
        this.shopInfos = data
        const { storeInfo } = data
        this.storeInfo = storeInfo
        // console.log(this.storeInfo)
      })
    },

    // 轮播图
    bannerInfo(id) {
      this.$http.get('/store/banner', { params: { storeId: id } }).then(res => {
        const { data } = res.data
        this.bannerInfos = data
        this.isCaseLunbo=this.bannerInfos.collect
        // console.log(this.bannerInfos.collect.length)
        this.smallCart=res.data.data.data;
        this.isCollect=this.smallCart.isCollect; //是否收藏了店铺
        console.log(this.bannerInfos,222)
      })
    },
    changeHandler(tab) {
      this.active = tab
      this.$emit('change', tab)
    },
    // 商家首页
    // shopHomePage() {
    //   this.$router.push({
    //     path: '/shopPage'
    //   })
    // },
    // 案例中心
    // shopCenterPage() {
    //   this.$router.push({
    //     path: '/caseCenter'
    //   })
    // },
    // // 企业信息
    // companyPage() {
    //   this.$router.push({
    //     path: '/companyInfo'
    //   })
    // }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/change.scss';
// .w100{
//   padding-top: 40px;
// }
*{
  margin:0;
  padding:0;
}
.shopNav {
  width: 100%;
  height: 40px;
  background: #333;
  // position: fixed;
  z-index: 30;
  .navContent {
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    cursor: pointer;
    background: #333;
    span {
      display: inline-block;
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      color: #fff;
      // &:hover {
      //   background: #0db168;
      //   color: #fff;
      // }
    }
    .active {
      color: #fff;
      background: #0db168;
    }
  }
}

.shopCommon {
  width: 100%;
  margin: 0 auto;
  // padding-top: 40px;
  .busWrap {
    padding-top: 20px;
    overflow: hidden;
  }
  .busLeft {
    width: 295px;
    height: 290px;
    border: 1px solid #e5e5e5;
    overflow:  hidden auto;
    padding-bottom: 20px;
    .top {
      overflow: hidden;
      margin: 15px 20px 0 15px;
      padding-bottom: 18px;
      border-bottom: 1px solid #e5e5e5;
      .logWrap {
        width: 72px;
        height: 72px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .logName {
        margin: 10px 0 0 15px;
        font-size: 15px;
        color: #666666;
        p {
          width: 170px;
          overflow: hidden;
          margin-bottom: 10px;
          font-size: 16px;
          color: #333333;
        }

        img {
          padding-right: 10px;
        }
      }
    }
    .down {
      padding: 15px 20px 18px 15px;
      font-size: 15px;
      color: #666666;
      p {
        margin-bottom: 10px;
        font-size: 14px;
        color: #333333;
      }

      .care {
        margin-left: 30px;
        img {
          margin-right: 6px;
        }
      }
    }
  }
  .busRight {
    // margin-left: 15px;
    .shopBanner {
      width: 100%;
      // height: 290px;
      height: 450px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        display:block;
      }
    }
  }
}
.about {
  overflow: hidden;
  max-height: 100%;
  margin-bottom: 20px;
  box-sizing: border-box;
  text-indent: 24px;
  // text-overflow: ellipsis;
  // display: -webkit-box;
  // -webkit-box-orient: vertical;
  // -webkit-line-clamp: 8;
}

// 以下轮播样式
/deep/ .el-carousel__container{
  height: 450px !important;
}

// 以下商铺轮播上小卡片样式
.shopInfoWrap{
    max-width: 1200px;
    margin:0 auto;
    background: transparent;
    position: relative;
   z-index: 10;
    .shopInfo{
        width: 340px;
        height: 410px;
        background: #fff;
        position: absolute;
        border-radius: 5px;
        top: 20px;
        right: 0;
        z-index: 10;
        padding-top: 10px;
        .shopName{
          width: 100%;
          height: 105px;
          // background: blue;
          display: flex;
          justify-content: flex-start;
          .shopName-left{
            width: 113px;
            height: 100%;
            display: flex;
            // flex: 0;
            justify-content: center;
            align-items: center;
            img{
              width: 80px;
              height: 80px;
              display: block;
              /*flex:0;*/
            }
          }
          .shopName-right{
            flex: 1;
            // background:red;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding:22px 0;
            >div{
              line-height: 32px;
            }
            .shopName-right_top{
              color:#333;
              font-weight: 900;
              width: 200px;
              // padding-right: 20px;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            }
            .shopName-right_bottom{
              color:#fff;
               display: flex;
                justify-content:flex-start;
                align-items: center;
              :first-child{
                background: #149cd3;
                margin-right: 8px;
              }
              :last-child{
                background: #fcc566;
              }
              span{
                  width: 20px;
                  height: 20px;
                  font-size: 15px;
                  line-height: 20px;
                  text-align: center;
                }
            }
          }

        }

        // 以下是产品数量部分代码
        .productNum{
          width: 303px;
          height: 82px;
          margin:0 auto;
          display: flex;
          justify-content: space-between;
          padding:0 15px;
          font-size: 15px;
          border-bottom: 1px solid #eee;
          dl{
            display: flex;
            flex-direction: column;
            justify-content:flex-start;
            dt{
              line-height: 35px;
              text-align: center;
              color: #656565;
              font-size: 20px;
              font-weight: 900;
            }
            dd{
              line-height: 35px;
              text-align: center;
              color: #343434;
            }
          }
        }

      .adress{
        width: 303px;
        max-height: 50px;
        line-height: 25px;
        margin:0 auto;
        margin-top: 20px;
        overflow: hidden;
        overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
        font-size: 15px;
      }

      .collection{
        width:260px;
        height:45px;
        margin:0 auto;
        border:1px solid #0db168;
        color: #0db168;
        font-size: 17px;
        border-radius: 3px;
        background: none;
        cursor: pointer;
        text-align: center;
        line-height: 45px;
        margin-top: 13px;
      }

      .contact{
        width:260px;
        height:45px;
        margin:0 auto;
        color: #fff;
        font-size: 17px;
        border-radius: 3px;
        background:#0db168;
        cursor: pointer;
        text-align: center;
        line-height: 45px;
        margin-top: 20px;
      }
    }
}

  //以下弹窗样式
/deep/ .el-dialog{
  width:440px;
  height:220px;
  margin-top:40vh !important;
  .el-dialog__body{
    padding:0;
  }
  .el-dialog__header{
      background: #f5f5f5;
  }
  .popTop{
    height:120px;
    .storeName{
      text-align: center;
      font-size:22px;
      color:#333;
      height:44px;
      line-height:44px;
      background: #f5f5f5;
    }
    .storeMobile{
      height:66px;
      line-height: 66px;
      font-size:28px;
      color:#333;
     background: #f5f5f5;
      >div{
        width:280px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin:0 auto;
        padding:0 10px;
        overflow: hidden;
        color:#333333;
        img{
          display: block;
        }
      }
      .streFooter{
        text-align: center;
        height: 80px;
        font-size: 12px;
        color: #999;
        display: flex;
        justify-content: center;
        line-height: 24px;
      }
    }
  }

}
</style>


